<template>
  <div id="advert_list" class="m_context">
    <!-- 条件筛选 -->
    <div class='rowFr'>
      <div class='rowa' style='padding-left:24px;width:calc(40% - 24px)'>
        <el-button type="success" @click="jump('/advert-list/new-ads')">{{$t('advert.addAdvert')}}</el-button>
        <el-button type="danger" @click="batchDelete">{{$t('advert.deleteAll')}}</el-button>
      </div>
      <div class='rowb' style='padding-right:24px;width:calc(60% - 24px)'>
        <el-col :span='6' style='padding-left:24px'>
          <el-select :placeholder="$t('lin_global.qxzlx')" v-model="filterParam.ad_type" @change='adTypeSelectChange'>
            <el-option :label="$t('app_alltyps')" value="-1"></el-option>
            <el-option v-for="item in adTypeList" :key="item.adtypeId" :value="item.adtypeId" :label="item.adtypeName"></el-option>
          </el-select>
        </el-col>
        <el-col :span='6' style='padding-left:16px'>
          <el-select :placeholder="$t('app_status')" v-model="listStatus" @change='statusChange'>
            <el-option v-for="item in stArray" :key="item.value" :value="item.value" :label="item.label"></el-option>
          </el-select>
        </el-col>
        <el-col :span='6' style='padding-left:16px;'>
          <el-select :placeholder="$t('app_selectPlayPlace')" v-model="filterParam.ad_position" @change='adPosSelectChange'>
              <el-option :label="$t('app_allpp')" value="-1"></el-option>
              <el-option :label="$t('advert.positionSub.banner')" value="0"></el-option>
              <el-option :label="$t('advert.positionSub.starPage')" value="1"></el-option>
            </el-select>
        </el-col>
        <el-col :span='6' style='padding-left:16px;'>
          <el-input  v-model="filterParam.ad_title" :placeholder="$t('app_inputName')" icon="search" :on-icon-click="searchFetch"></el-input>
        </el-col>
       
      </div>
    </div>
    <!-- <el-row>
      <el-col :span="8" class="btn_col">
        <el-button type="success" @click="jump('/advert-list/edit/0')">{{$t('advert.addAdvert')}}</el-button>
        <el-button type="danger" @click="batchDelete">{{$t('advert.deleteAll')}}</el-button>
      </el-col>
      <el-col :span="16" class="input_col fr">
        <el-form :inline="true" class="demo-form-inline" >
          <el-form-item >
            <el-select :placeholder="$t('lin_global.qxzlx')" v-model="filterParam.ad_type" @change='adTypeSelectChange'>
              <el-option :label="$t('app_alltyps')" value="-1"></el-option>
              <el-option v-for="item in adTypeList" :value="item.adtypeId" :label="item.adtypeName"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item >
            <el-select :placeholder="$t('app_selectPlayPlace')" v-model="filterParam.ad_position" @change='adPosSelectChange'>
              <el-option :label="$t('app_allpp')" value="-1"></el-option>
              <el-option :label="$t('advert.positionSub.banner')" value="0"></el-option>
              <el-option :label="$t('advert.positionSub.starPage')" value="1"></el-option>
            </el-select>
          </el-form-item>
       

          <el-form-item >
            <el-input  v-model="filterParam.ad_title" :placeholder="$t('app_inputName')" icon="search" :on-icon-click="searchFetch"></el-input>
          </el-form-item>
        </el-form>
      </el-col>
    </el-row> -->
    <!-- 条件筛选 END -->

    <!-- 操作按钮 -->
    <!--<el-row style="margin-bottom: 10px;">-->
      <!--<el-col :span="24">-->
        <!--<el-button type="success" size="small" @click="jump('/advert-list/edit/0')">{{$t('advert.addAdvert')}}</el-button>-->
        <!--<el-button type="danger" size="small" @click="batchDelete">{{$t('advert.deleteAll')}}</el-button>-->
      <!--</el-col>-->
    <!--</el-row>-->
    <!-- 操作按钮 END-->

    <!-- 表格列表 -->
    <el-table
      v-loading.body="loading"
      ref="multipleTable"
      :data="resultData"
      border
      tooltip-effect="dark"
      style="width: 100%"
      @selection-change="handleSelectionChange"
      @row-click="cellClick"
      >
      <el-table-column
        type="selection"
        width="55">
      </el-table-column>
      <el-table-column
        prop="adTitle"
        :label="$t('advert.name')">
      </el-table-column>
      <el-table-column
        prop="adType"
        :label="$t('advert.classify')"
        width="150">
        <template slot-scope="scope">

          <span v-for="(item,index) in adTypeList" :key="index" v-if="item.adtypeId === scope.row.adType">{{item.adtypeName}}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="adPosition"
        :label="$t('advert.position')" width="200">
        <template slot-scope="scope">
          <span v-if="scope.row.adPosition == 0">Banner</span>
          <span v-if="scope.row.adPosition == 1">Splash</span>
          <span v-if="scope.row.adPosition == 3">{{$t('app_appadv')}}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="adStartEnd"
        :label="$t('advert.ableDate')"
        :formatter="dateFormat"
        width="120">
      </el-table-column>
      <el-table-column
        prop="adStatus"
        :label="$t('advert.status')"
        width="120">
        <template slot-scope="scope">
          <span v-if="scope.row.adStatus == 0" style="color: #8492A6;">{{$t('advert.waitOne')}}</span>
          <span v-if="scope.row.adStatus == 1" style="color: #F7BA2A;">{{$t('advert.waitTwo')}}</span>
          <span v-if="scope.row.adStatus == 2" style="color:#13CE66;">{{$t('advert.pass')}}</span>
          <span v-if="scope.row.adStatus == 3" style="color: #FF4949;">{{$t('advert.notPass')}}</span>
          <span v-if="scope.row.adStatus == 4" style="color: #FF4949;">{{$t('app_ustart')}}</span>
          <span v-if="scope.row.adStatus == 5" style="color: #FF4949;">{{$t('app_outofdate')}}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="adCreateUsername"
        :label="$t('advert.addUser')"
        width="120">
      </el-table-column>
      <el-table-column
        prop="adCreateTime"
        :label="$t('advert.addDate')" width="180">
      </el-table-column>
      <el-table-column
        align='right'
        header-align="center"
        :label="$t('mao_global.btn.e')" width="110">
        <template slot-scope="scope">
          <!--未送审 和 未通过才允许修改-->
          <!-- <el-button type="text" v-if="scope.row.adStatus == 0 || scope.row.adStatus == 3" size="small" @click.stop="jumpToEdit(scope.row)">{{$t('mao_global.btn.edit')}}</el-button> -->

          <el-tooltip class="item" effect="dark" :content="$t('mao_global.btn.edit')" placement="top">
            <el-button type='text' v-if="scope.row.adStatus == 0 || scope.row.adStatus == 3 || scope.row.adStatus == 4 || scope.row.adStatus == 5" @click.stop="jumpToEdit(scope.row)"><i class="fa fa-pencil" style=""></i></el-button>
          </el-tooltip>

          <!-- <el-button type="text" size="small" v-if="scope.row.adStatus == 0 || scope.row.adStatus == 3" @click.stop="sbIsAble(scope.row.adId)">{{$t('mao_global.btn.submit')}}</el-button> -->
          <el-tooltip class="item" effect="dark" :content="$t('app_smVerify')" placement="top">
            <el-button type='text' v-if="scope.row.adStatus == 0 || scope.row.adStatus == 3" @click.stop="sbIsAble(scope.row.adId)"><i class="fa fa-arrow-up" style=""></i></el-button>
          </el-tooltip>

          <!--<el-button type="text" size="small" @click.stop="deleteRecord(scope.row.adId)">{{$t('mao_global.btn.delete')}}</el-button>-->

          <el-tooltip class="item" effect="dark" :content="$t('mao_global.btn.delete')" placement="top">
            <el-button @click.stop="deleteRecord(scope.row.adId)" type="text"><i class="fa fa-trash" style="color:#FF4949"></i></el-button>
          </el-tooltip>

        </template>
      </el-table-column>
    </el-table>
    <!-- 表格列表 END-->

    <!-- 分页 -->
    <paging :rdata="pagingData" :action="pAction"></paging>
    <!-- 分页 END -->

  </div>

</template>
<script>
  import mm from 'moment'
  import axios from 'axios'
  import { baseurl } from '../../api/url'
  import MPage from '@/components/global/paging.vue'
  export default{
    components: {
      paging: MPage
    },
    data(){
    	var that = this
      return {
    		// 多选框选择的值, 临时存储
        batchRecord: null,
        loading: true,
        adTypeList: null,
        listStatus: '',
      	pagingData: {
          total: 5,
          pageSize: 20,
          currentPage: 1
        },
        stArray: [
          {label: this.$t('lin_global.all_status'), value: ''},
          {label: this.$t('advert.waitOne'), value: '0'},
          {label: this.$t('advert.waitTwo'), value: '1'},
          {label: this.$t('advert.pass'), value: '2'},
          {label: this.$t('advert.notPass'), value: '3'},
          {label: this.$t('app_ustart'), value: '4'},
          {label: this.$t('app_outofdate'), value: '5'}
        ],
        resultData: [
//          {
//            adTitle: '',
//            adType: '',
//            adPosition: '首页banner',
//            adStartEnd: '2017-6-6',
//            adStatus: '未送审',
//            adCreateUsername: 'admin',
//            adCreateTime: '2017-11-11 10:00'
//          }
        ],
        // 条件筛选表单
        filterParam: {page: 1, rows: 20,ad_title: '',distributorId: localStorage.getItem('mechanismId'),ad_type: '-1',ad_position: '-1',ad_status: ''},
        pAction : {
          handleSizeChange (v) {
            that.filterParam['rows'] = v;
            that.filterParam['page'] = 1;
            that.fetchData()
          },
          handleCurrentChange (v) {
            that.filterParam['page'] = v;
            that.fetchData()
          }
        }
      }
    },
    mounted(){ 
    	var that = this

      that.fetchData(true)

      that.fetchTypeList();
    },
    methods:{
      statusChange () {
        this.fetchData(false)
      },
    	cellClick (row,event) {
    		var that = this
        if(event.target.className=='el-checkbox__original'||event.target.className=='el-checkbox__inner'){
          return false
        }else{
        	that.$router.push({path: '/advert-list/detail/' + row.adId})
        }
      },
    	// 批量删除
      batchDelete () {
        var that = this
        if (!that.batchRecord || that.batchRecord.length < 1) {
        	that.$message("没有选中记录")
          return false
        }

        var tmp = ""
        var len = that.batchRecord.length
        for (var i =0; i<len; i++) {
          var o = that.batchRecord[i]
          tmp += o['adId'] + ","
        }

        tmp = tmp.substr(0,tmp.length-1)


        that.deleteRecord(tmp)

      },
      // 提交审核结果
      sbIsAble (id) {
        var that = this

        var data = {
          ad_id: id,
          ad_status: 1,
          refuse_reason: ''
        }
        axios.post(`${baseurl}/admanage/examine.do`,data).then(res=>{
          that.$message(this.$t('app_opsuccess'))
          that.fetchData()
        })


      },
      dateFormat (row, column) {
        var date = row[column.property]
        if (date === undefined) {
          return ''
        }
        return mm(date).format('YYYY-MM-DD')
      },
    	fetchTypeList () {
    		var that = this
        axios.post(`${baseurl}/adType/list.do`,{'page':1, rows: 10000}).then(res=>{
          that.adTypeList = res.data.data
          that.loading = false
        })
      },
    	jump (url) {
    		this.$router.push({path: url})
      },
    	deleteRecord (id) {
    		var that = this

        that.$confirm(this.$t('mao_global.tip.confirmDelete'), this.$t('mao_global.tip.text'), {
          confirmButtonText: this.$t('mao_global.btn.ok'),
          cancelButtonText: this.$t('mao_global.btn.cancel'),
          type: 'warning'
        }).then(() => {
          let param = {"ad_id": id}
          axios.post(`${baseurl}/admanage/delete.do`,param).then(res=>{
            if (res.data && res.data.status && res.data.status === 200) {
              that.$message(this.$t('app_opsuccess'))
              that.fetchData(true)
            }
          })
        }).catch(() => {

        }); // end $confirm


      },
    	// 跳转到编辑页面
    	jumpToEdit (data) {
        var that = this
        that.$router.push({path: '/advert-list/edit/' + data.adId})
      },
      handleSelectionChange (v) {
        var that = this
        that.batchRecord = v
      },
      // 重置条件查询表单
      resetSearchForm () {
        var that = this
        that.filterParam['ad_title'] = ''
        that.filterParam['ad_type'] = '-1'
        that.filterParam['ad_position'] = '-1'

        //add by sing, 2017-07-08
        var that = this
        that.fetchData(true)
      },
      // 条件查询触发
      searchFetch () {
        var that = this
        that.fetchData()
      },
      // 初始化过滤参数
      initFilterParams () {
    		var that = this
        that.filterParam = {page: 1, rows: 20,ad_title: '',distributorId: localStorage.getItem('mechanismId'),ad_type: '-1',ad_position: '-1', ad_status: ''}
        return that.filterParam;
      },
      // 设置过滤参数
      setFilterParams () {

      },
    	// 初始化数据
      fetchData (bool) {

    		var that = this

        // 是否第一次初始化
        if (bool) that.initFilterParams()

        var smf = {
    			page: that.filterParam['page'],
          rows: that.filterParam['rows'],
          ad_title: that.filterParam['ad_title'],
          ad_type: that.filterParam['ad_type'],
          ad_position: that.filterParam['ad_position'],
          distributorId: localStorage.getItem('mechanismId'),
          ad_status: this.listStatus
    		}

        if (smf['ad_type'] === '-1') smf['ad_type'] = ''
        if (smf['ad_position'] === '-1') smf['ad_position'] = ''

        that.req.advert.list(smf).then(res =>{
          if (res.data && res.status && res.status === 200) {
            that.resultData = res.data
            // 获取当前条件查询下, 一共有多少条数据
            if (res.total) that.pagingData['total'] = res.total
          }
        })
//        axios.post(`${baseurl}/admanage/list.do`,smf).then(res=>{
//          if (res.data && res.data.status && res.data.status === 200) {
//            that.resultData = res.data.data
//            // 获取当前条件查询下, 一共有多少条数据
//            if (res.data.total) that.pagingData['total'] = res.data.total
//          }
//        })
      },
      adPosSelectChange (vl) {
      // add by sing, 2017-07-08
      // 切换列表自动查询
        var that = this
        that.fetchData()
      },
      adTypeSelectChange(vl) {
      // add by sing, 2017-07-08
      // 切换列表自动查询
        var that = this
        that.fetchData()
      }
    }
  }
</script>



// WEBPACK FOOTER //
// list.vue?b03e1ac4